export default "__VITE_ASSET__2560df90__"